var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgVolumeX = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3872 7.91249L10.0752 4.16207C10.5554 3.77795 11.2667 4.11981 11.2667 4.73471V18.4236C11.2667 19.0385 10.5554 19.3804 10.0752 18.9962L5.3872 15.2458H1.73333C1.32832 15.2458 1 14.9175 1 14.5125V8.64582C1 8.24081 1.32832 7.91249 1.73333 7.91249H5.3872ZM6.10255 9.21846C5.97252 9.32248 5.81096 9.37915 5.64444 9.37915H2.46667V13.7792H5.64444C5.81096 13.7792 5.97252 13.8358 6.10255 13.9398L9.8 16.8978V6.2605L6.10255 9.21846ZM20.3704 11.5792L22.7852 13.9939C23.0716 14.2803 23.0716 14.7446 22.7852 15.031C22.4988 15.3174 22.0345 15.3174 21.7481 15.031L19.3333 12.6162L16.9185 15.031C16.6322 15.3174 16.1678 15.3174 15.8815 15.031C15.5951 14.7446 15.5951 14.2803 15.8815 13.9939L18.2962 11.5792L15.8815 9.16437C15.5951 8.87798 15.5951 8.41366 15.8815 8.12728C16.1678 7.84089 16.6322 7.84089 16.9185 8.12728L19.3333 10.5421L21.7481 8.12728C22.0345 7.84089 22.4988 7.84089 22.7852 8.12728C23.0716 8.41366 23.0716 8.87798 22.7852 9.16437L20.3704 11.5792Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgVolumeX;